import { shape, arrayOf, string } from 'prop-types';

export default arrayOf(shape({
  colId: string,
  sort: string,
}));
